import { render } from "./Letter.vue?vue&type=template&id=11daba68&scoped=true"
import script from "./Letter.vue?vue&type=script&lang=js"
export * from "./Letter.vue?vue&type=script&lang=js"

import "./Letter.vue?vue&type=style&index=0&id=11daba68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11daba68"]])

export default __exports__